import React, { useEffect, useState } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { login } from "../../reducers/userSlice";
import { cargarOfficerPorRut } from "../../utils/Datos";

export const SuccessCuLogin = () => {
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = Object.fromEntries(new URLSearchParams(window.location.search));

  useEffect(() => {
    const loginClaveUnica = async () => {
      try {
        //console.log("Parámetros recibidos desde ClaveÚnica:", params);

        if (!params.run) {
          setError(true);
          setCargando(false);
          return;
        }

        const rut = params.run.replace(/\./g, "");

        const respuesta = await cargarOfficerPorRut(rut);

        //console.log("Respuesta officerRut:", respuesta);

        if (respuesta.status === true) {
          dispatch(
            login({
              user: {
                name: respuesta.officerName,
                id_officer: respuesta.id_officer,
                username: respuesta.user_name,
                run: respuesta.officerRut,
                email: respuesta.email,
                roles: respuesta.roles_qualifications,
                fecha_login: Date.now(),
              },
              loggedIn: true,
            })
          );

          navigate("/home");
        } else {
          Swal.fire({
            title: "No autorizado",
            text:
              respuesta.errores ??
              "No se encontró un funcionario asociado al RUT autenticado con ClaveÚnica.",
            icon: "error",
            confirmButtonText: "Ok",
          }).then(() => {
            setError(true);
          });
        }
      } catch (error) {
        console.error("Error login ClaveÚnica:", error);

        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al validar el inicio de sesión con ClaveÚnica.",
          icon: "error",
          confirmButtonText: "Ok",
        }).then(() => {
          setError(true);
        });
      }

      setCargando(false);
    };

    loginClaveUnica();
  }, []);

  return (
    <div className="container pt-4">
        <div className="row">
            <div className="col-md-12 text-center">
                <div className="card">
                <div className="card-body">
                    {cargando ? (
                    <Dimmer active inverted className="mt-5 mb-5">
                        <Loader
                        size="big"
                        inverted
                        content="Validando inicio de sesión con ClaveÚnica, espere un momento"
                        />
                    </Dimmer>
                    ) : !error ? (
                    <></>
                    ) : (
                        <>
                            <div className="alert alert-danger" role="alert">
                                <strong>Atención,</strong> no fue posible iniciar sesión con
                                ClaveÚnica. El RUT recibido no tiene un funcionario asociado o
                                los parámetros recibidos no son correctos.
                            </div>
                            <a href="/login" class="btn btn-primary"><i className="fas fa-chevron-left me-2"></i>Volver al inicio</a>
                        </>
                    )}
                </div>
                </div>
            </div>
        </div>
    </div>
  );
};